import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import InvoicePortal from './pages/InvoicePortal';
import TokenError from './pages/TokenError';
import InvoiceList from './pages/InvoiceList';
import RequireAuth from './components/RequireAuth';
import AdminPanel from './pages/AdminPanel';
import CreditCardRecon from './pages/CreditCardRecon';
// Phase 65: Purchase Orders
import PurchaseOrders  from './pages/PurchaseOrders';
import PORequestForm   from './pages/PORequestForm';
import PODetail        from './pages/PODetail';
import POApproval      from './pages/POApproval';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Token-based portals — no login required */}
          <Route path="/review"      element={<InvoicePortal />} />
          <Route path="/error"       element={<TokenError />} />
          <Route path="/po-approval" element={<POApproval />} />

          {/* Management portal — requires Entra login */}
          <Route path="/invoices" element={
            <RequireAuth>
              <InvoiceList />
            </RequireAuth>
          } />

          {/* Admin panel — requires Entra login (ADMIN role enforced in component) */}
          <Route path="/admin" element={
            <RequireAuth>
              <AdminPanel />
            </RequireAuth>
          } />

          {/* Credit Card Reconciliation — requires POWER_USER or ADMIN role */}
          <Route path="/credit-card-upload" element={
            <RequireAuth requiredRole="POWER_USER">
              <CreditCardRecon />
            </RequireAuth>
          } />

          {/* Purchase Orders (Phase 65) — requires Entra login; pages handle role-gating */}
          <Route path="/purchase-orders" element={
            <RequireAuth>
              <PurchaseOrders />
            </RequireAuth>
          } />
          <Route path="/purchase-orders/new" element={
            <RequireAuth>
              <PORequestForm />
            </RequireAuth>
          } />
          <Route path="/purchase-orders/:id" element={
            <RequireAuth>
              <PODetail />
            </RequireAuth>
          } />
          <Route path="/purchase-orders/:id/edit" element={
            <RequireAuth>
              <PORequestForm />
            </RequireAuth>
          } />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/invoices" replace />} />
          <Route path="*" element={<Navigate to="/invoices" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
